// app/javascript/globals.js

// Define globally on window
window.numWithCommas = function(num) {
  return (num || 0).toLocaleString();
};
